export default __webpack_public_path__ + "static/media/igevent.faaba1df.png";